<template>
  <el-container class="footerBg" style="width: 100%; height: 100%;">
    <el-header class="container" style="height: 100%;">
      <div class="footTop">
        <div>
          <ul class="footLink list-unstyled list-inline">
            <li>
              <h3><a class="ellipsis" href="#">关于我们</a></h3>
              <div class="footSub">
                <p><a class="ellipsis" href="#/company">关于我们</a></p>
                <p><a class="ellipsis" href="#/contact">联系我们</a></p>
                <p>
                  <a
                    class="ellipsis"
                    href="https://www.foxlean.com/user-agreement.html"
                    >使用协议</a
                  >
                </p>
                <p>
                  <a
                    class="ellipsis"
                    href="https://www.foxlean.com/user-privacy-agreement.html"
                    >隐私保护</a
                  >
                </p>
              </div>
            </li>
            <li>
              <h3><a class="ellipsis" href="#/download">应用程序</a></h3>
              <div class="footSub">
                <p><a class="ellipsis" href="#/download">iOS App</a></p>
                <p><a class="ellipsis" href="#/download">Android App</a></p>
                <p><a class="ellipsis" href="#/download">TV App</a></p>
                <p><a class="ellipsis" href="#/download">Web 管理</a></p>
                <p><a class="ellipsis" href="#/download">工位平板 App</a></p>
                <p><a class="ellipsis" href="#/download">Windows App</a></p>
              </div>
            </li>
            <li>
              <h3>
                <a class="ellipsis" href="#">产品资料</a>
              </h3>
              <div class="footSub">
                <p><a class="ellipsis" href="#/module">玩转工厂介绍</a></p>
                <p>
                  <a class="ellipsis" href="http://www.foxlean.com:8003/docs/"
                    >玩转工厂使用指南</a
                  >
                </p>
              </div>
            </li>
            <li>
              <h3><a class="ellipsis" href="#/contact">购买合作</a></h3>
              <div class="footSub">
                <p><a class="ellipsis" href="#/contact">价格体系</a></p>
                <p><a class="ellipsis" href="#/contact">联系销售</a></p>
                <p><a class="ellipsis" href="#/contact">代理合作</a></p>
                <p><a class="ellipsis" href="#/contact">产品试用</a></p>
                <p><a class="ellipsis" href="#/contact">应用培训</a></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-header>
    <el-footer class="footerLink">
      <p class="text-center">
        Copyright©2018
        <a href="https://www.foxlean.com">www.foxlean.com</a> All Rights
        Reserved
        <a href="https://www.foxlean.com">益狐智造科技（武汉）有限公司</a>
        <br />鄂ICP备18005205号-1
      </p>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "HomeFooter"
};
</script>

<style lang="stylus" scoped>
.div-content {
  position: relative;
}

.bg-img {
  width: 100%;
  background-image: "@/assets/images/home-footer.png";
}
.footerBg{ background:#333333; font-size:12px; color:#777777; line-height:26px;}

.p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  font-size: 0.6rem;
  color: rgba(255, 255, 255, 0.7);
}
.footTop { padding:40px 0;}
.footTopR{ float:none; text-align:center; padding-bottom:15px;}
.footerLink { display:block; width:100% !important; max-width:none; border-top:1px dashed rgba(255,255,255,0.1); padding:5px 0;}
.footLink li:last-child{ border:none; padding-bottom:0;}
.footLink{ font-size:0;}
.footLink li{ vertical-align:top; float: left; font-size:12px; margin-right:0px; max-width:25%; min-width: 25%}
.footLink li:last-child{ margin-right:0;}
.footLink h3 a{ font-size:16px; font-weight:bold; line-height:200%; color:#eeeeee;}
.ellipsis{ display:block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden;}
.footSub{ padding:20px 0 0;}
.footSub a{ font-size:12px; color:#777777; line-height:26px;}
.footSub a:hover{ color:#FFFFFF; transition:all 0.3s ease 0s;}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Footer.vue